// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_uiKitDocs__RzqSm {
  padding: 2rem;
  min-height: 100vh;
  background: #f8f9fa; }

.styles_componentList__DKV1J .styles_componentsGrid__bfA\\+Y {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 1.5rem; }

.styles_componentList__DKV1J .styles_componentCard__dtGVu {
  cursor: pointer;
  transition: all 0.2s ease;
  border: 1px solid #e9ecef; }
  .styles_componentList__DKV1J .styles_componentCard__dtGVu:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); }

.styles_componentList__DKV1J .styles_componentPreview__8f3PK {
  padding: 1rem;
  background: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  margin-top: 1rem; }

.styles_componentDetail__nZoCM .styles_description__v4nf7 {
  font-size: 1.1rem;
  color: #6c757d;
  line-height: 1.6; }

.styles_componentDetail__nZoCM .styles_propsTable__fEzdj {
  margin: 2rem 0; }
  .styles_componentDetail__nZoCM .styles_propsTable__fEzdj table {
    width: 100%;
    border-collapse: collapse;
    background: white;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); }
    .styles_componentDetail__nZoCM .styles_propsTable__fEzdj table th, .styles_componentDetail__nZoCM .styles_propsTable__fEzdj table td {
      padding: 1rem;
      text-align: left;
      border-bottom: 1px solid #e9ecef; }
    .styles_componentDetail__nZoCM .styles_propsTable__fEzdj table th {
      background: #f8f9fa;
      font-weight: 600;
      color: #495057; }
    .styles_componentDetail__nZoCM .styles_propsTable__fEzdj table td {
      vertical-align: top; }
    .styles_componentDetail__nZoCM .styles_propsTable__fEzdj table code {
      background: #e9ecef;
      padding: 0.2rem 0.4rem;
      border-radius: 3px;
      font-size: 0.9rem; }
  .styles_componentDetail__nZoCM .styles_propsTable__fEzdj .styles_options__7sSsn {
    font-size: 0.8rem;
    color: #6c757d;
    margin-top: 0.25rem; }

.styles_componentDetail__nZoCM .styles_examples__8AiSU .styles_exampleCard__yNXIc {
  border: 1px solid #e9ecef;
  margin-bottom: 1.5rem; }

.styles_componentDetail__nZoCM .styles_examples__8AiSU .styles_exampleCode__ZszyE {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
  border: 1px solid #e9ecef; }
  .styles_componentDetail__nZoCM .styles_examples__8AiSU .styles_exampleCode__ZszyE code {
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
    font-size: 0.9rem;
    color: #495057; }

.styles_componentDetail__nZoCM .styles_examples__8AiSU .styles_examplePreview__a7spu {
  padding: 1rem;
  background: white;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60px; }

.styles_allExamplesModal__JDWaP {
  max-width: 800px;
  max-height: 80vh;
  overflow-y: auto;
  padding: 2rem; }
  .styles_allExamplesModal__JDWaP .styles_modalComponent__kLYew {
    margin-bottom: 2rem;
    padding-bottom: 2rem;
    border-bottom: 1px solid #e9ecef; }
    .styles_allExamplesModal__JDWaP .styles_modalComponent__kLYew:last-child {
      border-bottom: none; }
  .styles_allExamplesModal__JDWaP .styles_modalExamples__eNQzI {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 1rem;
    margin-top: 1rem; }
  .styles_allExamplesModal__JDWaP .styles_modalExample__\\+Un4N {
    padding: 1rem;
    background: #f8f9fa;
    border-radius: 4px;
    border: 1px solid #e9ecef;
    text-align: center; }

.styles_codeBlock__n\\+uOv {
  background: #f8f9fa;
  padding: 1rem;
  border-radius: 4px;
  border: 1px solid #e9ecef;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 0.9rem;
  color: #495057;
  white-space: pre-wrap; }

@media (max-width: 768px) {
  .styles_uiKitDocs__RzqSm {
    padding: 1rem; }
  .styles_componentList__DKV1J .styles_componentsGrid__bfA\\+Y {
    grid-template-columns: 1fr; }
  .styles_componentDetail__nZoCM .styles_propsTable__fEzdj table th, .styles_componentDetail__nZoCM .styles_propsTable__fEzdj table td {
    padding: 0.5rem;
    font-size: 0.9rem; }
  .styles_allExamplesModal__JDWaP {
    padding: 1rem; }
    .styles_allExamplesModal__JDWaP .styles_modalExamples__eNQzI {
      grid-template-columns: 1fr; } }
`, "",{"version":3,"sources":["webpack://./src/modules/Core/sub-modules/ui-kit/UIKitDocs/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB,EAAA;;AAGrB;EAEI,aAAa;EACb,4DAA4D;EAC5D,WAAW,EAAA;;AAJf;EAQI,eAAe;EACf,yBAAyB;EACzB,yBAAyB,EAAA;EAV7B;IAaM,2BAA2B;IAC3B,yCAAyC,EAAA;;AAd/C;EAmBI,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB,EAAA;;AAIpB;EAEI,iBAAiB;EACjB,cAAc;EACd,gBAAgB,EAAA;;AAJpB;EAQI,cAAc,EAAA;EARlB;IAWM,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,wCAAwC,EAAA;IAhB9C;MAmBQ,aAAa;MACb,gBAAgB;MAChB,gCAAgC,EAAA;IArBxC;MAyBQ,mBAAmB;MACnB,gBAAgB;MAChB,cAAc,EAAA;IA3BtB;MA+BQ,mBAAmB,EAAA;IA/B3B;MAmCQ,mBAAmB;MACnB,sBAAsB;MACtB,kBAAkB;MAClB,iBAAiB,EAAA;EAtCzB;IA2CM,iBAAiB;IACjB,cAAc;IACd,mBAAmB,EAAA;;AA7CzB;EAmDM,yBAAyB;EACzB,qBAAqB,EAAA;;AApD3B;EAwDM,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB,EAAA;EA5D/B;IA+DQ,wDAAwD;IACxD,iBAAiB;IACjB,cAAc,EAAA;;AAjEtB;EAsEM,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB,EAAA;;AAKtB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa,EAAA;EAJf;IAOI,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC,EAAA;IATpC;MAYM,mBAAmB,EAAA;EAZzB;IAiBI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,gBAAgB,EAAA;EApBpB;IAwBI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB,EAAA;;AAItB;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,wDAAwD;EACxD,iBAAiB;EACjB,cAAc;EACd,qBAAqB,EAAA;;AAIvB;EACE;IACE,aAAa,EAAA;EAGf;IAEI,0BAA0B,EAAA;EAI9B;IAIQ,eAAe;IACf,iBAAiB,EAAA;EAMzB;IACE,aAAa,EAAA;IADf;MAII,0BAA0B,EAAA,EAC3B","sourcesContent":[".uiKitDocs {\n  padding: 2rem;\n  min-height: 100vh;\n  background: #f8f9fa;\n}\n\n.componentList {\n  .componentsGrid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n    gap: 1.5rem;\n  }\n\n  .componentCard {\n    cursor: pointer;\n    transition: all 0.2s ease;\n    border: 1px solid #e9ecef;\n    \n    &:hover {\n      transform: translateY(-2px);\n      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n    }\n  }\n\n  .componentPreview {\n    padding: 1rem;\n    background: #f8f9fa;\n    border-radius: 4px;\n    border: 1px solid #e9ecef;\n    margin-top: 1rem;\n  }\n}\n\n.componentDetail {\n  .description {\n    font-size: 1.1rem;\n    color: #6c757d;\n    line-height: 1.6;\n  }\n\n  .propsTable {\n    margin: 2rem 0;\n    \n    table {\n      width: 100%;\n      border-collapse: collapse;\n      background: white;\n      border-radius: 8px;\n      overflow: hidden;\n      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n      \n      th, td {\n        padding: 1rem;\n        text-align: left;\n        border-bottom: 1px solid #e9ecef;\n      }\n      \n      th {\n        background: #f8f9fa;\n        font-weight: 600;\n        color: #495057;\n      }\n      \n      td {\n        vertical-align: top;\n      }\n      \n      code {\n        background: #e9ecef;\n        padding: 0.2rem 0.4rem;\n        border-radius: 3px;\n        font-size: 0.9rem;\n      }\n    }\n\n    .options {\n      font-size: 0.8rem;\n      color: #6c757d;\n      margin-top: 0.25rem;\n    }\n  }\n\n  .examples {\n    .exampleCard {\n      border: 1px solid #e9ecef;\n      margin-bottom: 1.5rem;\n    }\n\n    .exampleCode {\n      background: #f8f9fa;\n      padding: 1rem;\n      border-radius: 4px;\n      margin-bottom: 1rem;\n      border: 1px solid #e9ecef;\n      \n      code {\n        font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n        font-size: 0.9rem;\n        color: #495057;\n      }\n    }\n\n    .examplePreview {\n      padding: 1rem;\n      background: white;\n      border-radius: 4px;\n      border: 1px solid #e9ecef;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      min-height: 60px;\n    }\n  }\n}\n\n.allExamplesModal {\n  max-width: 800px;\n  max-height: 80vh;\n  overflow-y: auto;\n  padding: 2rem;\n\n  .modalComponent {\n    margin-bottom: 2rem;\n    padding-bottom: 2rem;\n    border-bottom: 1px solid #e9ecef;\n    \n    &:last-child {\n      border-bottom: none;\n    }\n  }\n\n  .modalExamples {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 1rem;\n    margin-top: 1rem;\n  }\n\n  .modalExample {\n    padding: 1rem;\n    background: #f8f9fa;\n    border-radius: 4px;\n    border: 1px solid #e9ecef;\n    text-align: center;\n  }\n}\n\n.codeBlock {\n  background: #f8f9fa;\n  padding: 1rem;\n  border-radius: 4px;\n  border: 1px solid #e9ecef;\n  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;\n  font-size: 0.9rem;\n  color: #495057;\n  white-space: pre-wrap;\n}\n\n// Responsive design\n@media (max-width: 768px) {\n  .uiKitDocs {\n    padding: 1rem;\n  }\n\n  .componentList {\n    .componentsGrid {\n      grid-template-columns: 1fr;\n    }\n  }\n\n  .componentDetail {\n    .propsTable {\n      table {\n        th, td {\n          padding: 0.5rem;\n          font-size: 0.9rem;\n        }\n      }\n    }\n  }\n\n  .allExamplesModal {\n    padding: 1rem;\n    \n    .modalExamples {\n      grid-template-columns: 1fr;\n    }\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"uiKitDocs": `styles_uiKitDocs__RzqSm`,
	"componentList": `styles_componentList__DKV1J`,
	"componentsGrid": `styles_componentsGrid__bfA+Y`,
	"componentCard": `styles_componentCard__dtGVu`,
	"componentPreview": `styles_componentPreview__8f3PK`,
	"componentDetail": `styles_componentDetail__nZoCM`,
	"description": `styles_description__v4nf7`,
	"propsTable": `styles_propsTable__fEzdj`,
	"options": `styles_options__7sSsn`,
	"examples": `styles_examples__8AiSU`,
	"exampleCard": `styles_exampleCard__yNXIc`,
	"exampleCode": `styles_exampleCode__ZszyE`,
	"examplePreview": `styles_examplePreview__a7spu`,
	"allExamplesModal": `styles_allExamplesModal__JDWaP`,
	"modalComponent": `styles_modalComponent__kLYew`,
	"modalExamples": `styles_modalExamples__eNQzI`,
	"modalExample": `styles_modalExample__+Un4N`,
	"codeBlock": `styles_codeBlock__n+uOv`
};
export default ___CSS_LOADER_EXPORT___;
